'use strict';

var App = require('app');
var AppState = require('app_state');
var Consts = require('consts');
var Decorator = require('utils/decoration');
var Device = require('models/devices');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var Validator = require('utils/validation');

var AddDeviceWizardView = Marionette.LayoutView.extend({
    template: require('components/devices/templates/common/add_device_wizard'),

    regions: {
        config: '#config',
    },

    ui: {
        btnNext: 'button#js-next',
        btnPrev: 'button#js-prev',
        ddlContract: 'select.js-contract',
    },

    events: {
        'click @ui.btnNext': 'next',
        'click @ui.btnPrev': 'prev',
        'change #parent_select-input': 'changeParent',
    },

    initialize: function (options) {
        var self = this;

        this.activeTab = 1;
        this.specialMode = options.mode; // 'fixedActive' or 'fixedPassive'

        this.form = this.form || { parent_select: options.parent };
        this.errors = {};
        this.deviceType = options.type || 'active';

        this.availableParents = [];
        this.selectedParent = options.parent;

        var categoryNames = _.uniq(
            _.flatten(
                Misc.selectWhere(
                    Consts.CategoryData,
                    function (item) {
                        return item.canAdd && item.connectsTo;
                    },
                    function (item) {
                        return item.connectsTo;
                    }
                )
            )
        );
        this.connectedToCategories = _.map(categoryNames, function (item) {
            return Consts.DeviceCategory[item].category;
        });

        var allDeviceCategories = [];
        _.each(Consts.CategoryData, function (data, cat) {
            if (data.canAdd) {
                allDeviceCategories.push({ name: data.addText, category: Consts.Category[cat] });
            }
        });
        var allowedDevices = options.subDevices || 'all';

        var catCount = AppState.getAvailableCategoryCount();
        this.availableParents = _.reduce(
            _.map(this.connectedToCategories, function (cat) {
                return catCount[cat];
            }),
            function (orig, item) {
                return Math.max(orig, item || 0);
            },
            0
        );

        // all categories that can be connected to any from categories
        this.availableDeviceCategories = _.sortBy(
            Misc.selectWhere(
                _.pairs(Consts.CategoryData),
                function (item) {
                    var catData = item[1];
                    if (!catData.canAdd) return false;

                    // item.connectsTo -> list of categories where the device can be connected to
                    return (
                        _.where(catData.connectsTo, function (connectTo) {
                            return catCount[connectTo] > 0;
                        }).length > 0
                    );
                },
                function (item) {
                    return {
                        category: item[1].category,
                        name: item[1].addText,
                    };
                }
            ),
            function (item) {
                return item.name;
            }
        );
        this.form.category = options.category || (this.availableDeviceCategories[0] || {}).category;
    },

    initializeTypeListener: function () {
        var self = this;
        $('.panel-heading a').on('click', function (e) {
            self.deviceType = e.currentTarget.id.substr(3);
            if ($(this).parents('.panel').children('.panel-collapse').hasClass('in')) {
                e.stopPropagation();
            }
            e.preventDefault();

            // 'passive' device and no parents available? -> disable 'next'
            self.ui.btnNext.prop('disabled', self.deviceType === 'passive' && self.availableParents.length == 0);
        });
    },

    onAttach: function () {
        this.initializeTypeListener();
    },

    onRender: function () {
        this.initializeTypeListener();
        this.initDevicePicker();
        Misc.initSelectPicker();

        if (this.activeTab === 1) {
            // do nothing on first wizard page
            return;
        }

        var getConfigCallback = function () {
            return function (success, id, category) {
                Decorator.enableElement('.modal-dialog');
                if (success) {
                    App.trigger(category + ':show', id);
                }
            };
        };

        // configuration wizard page -> initialize sub-view
        var categoryKey = this.connectedTo !== undefined ? this.connectedToCategory : this.form.category;

        var view = App.DevicesCategoryObj[categoryKey].settingsView;
        var controller = App.DevicesCategoryObj[categoryKey].controller;

        this.configView = new view({
            model: this.connectedTo,
            categoryKey: categoryKey,
            controller: new controller({ deviceCategory: categoryKey }),
            dialog: this,
            parent_id: this.form.parent_select,
            cb: getConfigCallback(),
        });

        this.showChildView('config', this.configView);
    },

    prepareMacAddress: function (mac) {
        // remove separator chars :, -, blank
        mac = mac.replace(/[:-\s]/gi, '');
        // prepend company mac prefix
        mac = '00E099' + mac;
        return mac;
    },

    next: function (e) {
        e.preventDefault();
        var self = this;
        this.isConnected = false;

        if (this.activeTab === 1) {
            // validate device type configuration
            this.form = Backbone.Syphon.serialize(this);

            var isActive = this.deviceType == 'active';
            if (
                isActive &&
                Validator.validateText(
                    this.form.connected_to_id,
                    4,
                    RegExp('([0-9A-Fa-f]{2}[:-\\s]?){1,5}([0-9A-Fa-f]{2})', 'i')
                ).length !== 0
            ) {
                // invalid (gateway) MAC address
                Decorator.flash($('#connected_to_id-input'));
                return;
            }

            if (isActive) {
                // get (already existing) gateway device
                Decorator.disableElement('.modal-dialog');

                var device = App.request('device:list', {
                    filterParams: {
                        macAddress: this.prepareMacAddress(this.form.connected_to_id),
                        mode: 'reg',
                        connectable: true,
                    },
                    onError: 'JSON',
                });
                $.when(device).done(function (response) {
                    if (response && response.items) {
                        response = response.items;
                    }

                    response = response || {};
                    if (response.failure_reason || !response.models || response.models.length === 0) {
                        switch (response.failure_reason) {
                            case 'device_never_called':
                                self.errors.mac = i18n.TR('Das Gerät hat sich noch nie beim Portal gemeldet.');
                                break;
                            case 'registration_period_expired':
                                self.errors.mac = i18n.TR(
                                    'Der Registrierungszeitraum ist abgelaufen. Bitte starten Sie das Gerät neu und versuchen sie es erneut.'
                                );
                                break;
                            case 'already_registered':
                                self.errors.mac = i18n.TR(
                                    'Das Gerät mit der angegebenen ID (MAC-Adresse) ist bereits registriert.'
                                );
                                break;
                            case 'unknown_device':
                                self.errors.mac = i18n.TR('Kein Gerät mit der angegebenen ID (MAC-Adresse) gefunden.');
                                break;
                            default:
                                self.errors.mac = i18n.TR('Unbekannter Fehler');
                        }
                    } else {
                        self.isConnected = true;
                        self.connectedTo = response.models[0];
                        self.connectedToCategory = response.models[0].get('category');
                        self.activeTab = 2;
                    }
                    Decorator.enableElement('.modal-dialog');
                    self.render();
                });
            } else {
                // just goto next page (new device will be created as last step)
                this.activeTab = 2;
                this.render();
            }
        } else {
            // delegate to mapped configuration view
            var fct = this.handleContractNr();
            this.configView.validateForm(
                undefined,
                function (settingsView, deviceModel) {
                    var callbackWasHandled = false;
                    fct(deviceModel);

                    // RegCom-TCP-Gateway? -> register its controller
                    if (deviceModel.attributes.type === Consts.GatewayTypeIDs.RegComTCP) {
                        // update the Gateway name stored in AppState
                        AppState.registerDevices([deviceModel.attributes]);
                        var model = new Device.Model({
                            parent: deviceModel.id,
                            wired_to: deviceModel.id,
                            name: deviceModel.attributes.name + ' - ' + i18n.TR('Regler'),
                            station: deviceModel.attributes.controller_station_address,
                            key_number: 1732,
                            category: Consts.Category.Controller,
                        });
                        settingsView.createModel.call(settingsView, undefined, model);
                        callbackWasHandled = true;
                    }
                    return callbackWasHandled;
                },
                function (settingsView, deviceModel) {
                    fct(deviceModel);
                    return false;
                }
            );
        }
    },

    handleContractNr: function () {
        if (this.isConnected) {
            return function () {};
        }
        var contractNrList = AppState.getContractNrList();
        const idx = this.ui.ddlContract.val();
        var contractNr =
            contractNrList.length > 1
                ? Misc.selectWhereFirst(
                      contractNrList,
                      function (item) {
                          return item.idx == idx;
                      },
                      null
                  )
                : undefined;

        if (!contractNr) {
            return function () {};
        }

        return function (deviceModel) {
            deviceModel.set('contract_nr', contractNr.nr);
            $.when(App.request('device:contract:set', deviceModel.id, contractNr.nr)).done(function (result) {
                if (!result) {
                    Notification.error(i18n.TR('Die Vertragsnummer konnte nicht gespeichert werden.'));
                }
            });
        };
    },

    prev: function (e) {
        e.preventDefault();

        this.errors = {};
        this.activeTab = 1;

        this.render();
    },

    onShow: function () {
        this.initDevicePicker();
        Misc.initSelectPicker();
    },

    initDevicePicker: function () {
        var self = this;
        Misc.initDevicePicker({
            selectFirst: true,
            onInitialized: function () {
                self.enableDeviceCategories();
            },
            filter: function () {
                return { connectable: true };
            },
        });
    },

    changeParent: function () {
        this.enableDeviceCategories();
    },

    enableDeviceCategories: function () {
        var form = Backbone.Syphon.serialize(this);
        var deviceInfo = AppState.getDeviceInfo(form.parent_select);

        var checkedItem = undefined;
        var firstEnabled = undefined;

        _.each($('.radio input'), function (radioItem) {
            var category = radioItem.value;
            var cd = Consts.DeviceCategory[category];
            var canConnect = Misc.countWhere(cd.connectsTo, function (item) {
                return item == deviceInfo.category;
            });
            checkedItem = radioItem.checked ? radioItem : checkedItem;

            if (canConnect || deviceInfo.isEthernetController) {
                $(radioItem).prop('disabled', false);
                firstEnabled = radioItem;
            } else {
                $(radioItem).prop('disabled', true);
            }
        });

        if (checkedItem && checkedItem.disabled) {
            $(checkedItem).prop('checked', false);
        }

        if (!checkedItem || checkedItem.disabled) {
            $(firstEnabled).prop('checked', true);
        }
    },

    serializeData: function () {
        var data = Marionette.LayoutView.prototype.serializeData.apply(this, arguments);

        data.activeTab = this.activeTab;
        data.showActive = this.specialMode === undefined || this.specialMode === 'fixedActive';
        data.showPassive = this.specialMode === undefined || this.specialMode === 'fixedPassive';

        data.hideAccordion = this.specialMode !== undefined;

        data.deviceType = this.deviceType;

        data.errors = this.errors;
        data.form = this.form;

        data.availableParents = this.availableParents;
        data.selectedParent = this.selectedParent;

        data.availableDeviceCategories = this.availableDeviceCategories;
        data.contractNrList = AppState.getContractNrList();
        data.contractNrList = data.contractNrList.length > 1 && this.isConnected && data.contractNrList;
        data.contractNr = '0';
        data.isConnected = this.isConnected;

        return data;
    },
});

module.exports = AddDeviceWizardView;
